import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ResponsiveValue,
  useToast,
} from '@chakra-ui/react';
import { createElement, FunctionComponent } from 'react';
import { AddModalProps } from '../../types';
import { UseMutationOptions } from 'react-query';

export function AddModelModal<T>({
  modelName,
  form,
  onClose,
  onModelAdded,
  instance,
  isOpen,
  size = 'md',
}: {
  modelName: string;
  form: FunctionComponent<AddModalProps<T>>;
  onClose: () => void;
  onModelAdded: () => void;
  isOpen: boolean;
  instance?: T;
  size?: ResponsiveValue<string>;
}) {
  const toast = useToast();
  const options: UseMutationOptions<unknown, unknown, any> = {
    onSuccess() {
      toast({
        title: 'Sucesso',
        description: `${modelName} ${!instance ? 'adicionado(s)' : 'editado'} com sucesso`,
        status: 'success',
      });
      onModelAdded();
      onClose();
    },
    onError() {
      toast({
        title: 'Erro',
        description: `Não foi possivel ${
          !instance ? 'adicionar' : 'editar'
        } o(s) ${modelName}. Por favor verifique os dados e tente novamente ou entre em contato com suporte@partiu.com.br.`,
        status: 'error',
      });
    },
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay backdropFilter={'blur(5px)'} />
      <ModalContent minWidth={size} paddingBottom={'15px'}>
        <ModalHeader>
          {instance ? 'Editar' : 'Adicionar'} {modelName}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>{createElement(form, { onClose, onModelAdded, toast, options, instance })}</ModalBody>
      </ModalContent>
    </Modal>
  );
}
